"use client";
import { rem } from "../../core/utils/units-converters/rem.mjs";
//#region packages/@mantine/core/src/components/Title/get-title-size.ts
const headings = [
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6"
];
const sizes = [
	"xs",
	"sm",
	"md",
	"lg",
	"xl"
];
function getTitleSize(order, size) {
	const titleSize = size !== void 0 ? size : `h${order}`;
	if (headings.includes(titleSize)) return {
		fontSize: `var(--mantine-${titleSize}-font-size)`,
		fontWeight: `var(--mantine-${titleSize}-font-weight)`,
		lineHeight: `var(--mantine-${titleSize}-line-height)`
	};
	else if (sizes.includes(titleSize)) return {
		fontSize: `var(--mantine-font-size-${titleSize})`,
		fontWeight: `var(--mantine-h${order}-font-weight)`,
		lineHeight: `var(--mantine-h${order}-line-height)`
	};
	return {
		fontSize: rem(titleSize),
		fontWeight: `var(--mantine-h${order}-font-weight)`,
		lineHeight: `var(--mantine-h${order}-line-height)`
	};
}
//#endregion
export { getTitleSize };

//# sourceMappingURL=get-title-size.mjs.map